import React from 'react';
import { styled } from '@mui/system';

export const CustomDialogContent = styled('div')((props) => ({
    padding: props.isMobile ? '8px 24px 32px 24px' : '0px 40px 66px 40px',
    backgroundColor: props.theme.palette.background.dialog
}))

export default CustomDialogContent
